'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useUser } from '@/hooks/useUser'
import SvgSpinnerBlue from '@/components/icons/spinner-blue'

// One front door (Mike, 8 Sep): examsolutions.net owns the whole public
// journey, so the app root only serves signed-in users. Logged-out visitors
// are sent to the main site; signed-in users keep the old withAnonymous
// behavior (redirect to their role home). Deep links (/login, /papers,
// /courses, papers, lessons) are untouched - only the root changes.
//
// Environment-aware (Pavlo, 14 Sep): the bounce belongs to the production host
// only. Anywhere else - sandbox, branch previews, local - a signed-out visitor
// goes to /login instead, so a preview link is self-contained rather than
// ejecting whoever opens it onto the live marketing site. Same class of bug
// getAppOrigin() was written for: a hardcoded canonical URL that is correct in
// exactly one environment and wrong in every other.
const PRODUCTION_APP_HOST = 'app.examsolutions.net'

const Page = () => {
  const { user, isInitialized } = useUser()
  const router = useRouter()

  useEffect(() => {
    if (!isInitialized) {
      return
    }

    if (user) {
      router.replace(`/${user.role}`)
    } else if (window.location.hostname === PRODUCTION_APP_HOST) {
      window.location.replace('https://examsolutions.net')
    } else {
      router.replace('/login')
    }
  }, [isInitialized, user, router])

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-v8-paper">
      <SvgSpinnerBlue withyMargin={false} classess="w-6 h-6" />
    </div>
  )
}

export default Page
